import { render } from "./Custom.vue?vue&type=template&id=3f5b3afd"
const script = {}

import exportComponent from "/tmp/workspace/staging/leadgen/email-builder/ghl-chat-widget/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__